import { CidadaoAtendimentoSelectFieldModel } from 'components/form'
import createDecorator, { Calculation } from 'final-form-calculate'
import { MetaPath, metaPath } from 'util/metaPath'

import {
  AgendamentoConsultaCompartilhadaModel,
  AgendamentoConsultaModel,
  AgendamentoReservaModel,
  ContatoCidadaoAgendamento,
} from '../model-agenda'

export function limparHorarioFinal(horarioInicial: Date | undefined): null | undefined {
  return horarioInicial ? undefined : null
}

export function createContatoCidadaoAgendamentoCalculation(
  contatoCidadaoPath: MetaPath<ContatoCidadaoAgendamento>
): Calculation {
  return {
    field: contatoCidadaoPath.email.absolutePath(),
    updates: {
      [contatoCidadaoPath.enviarEmail.absolutePath()]: (email: string | null | undefined) => {
        return email ? undefined : false
      },
    },
  }
}

const metaConsulta = metaPath<AgendamentoConsultaModel>()

const agendamentoConsultaCalculations = [
  {
    field: metaConsulta.cidadao.absolutePath(),
    updates: {
      [metaConsulta.contatoCidadao.email.absolutePath()]: (cidadaoValue: CidadaoAtendimentoSelectFieldModel) =>
        cidadaoValue?.contato.email,
      [metaConsulta.contatoCidadao.telefoneCelular.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato.telefoneCelular,
    },
  },
  createContatoCidadaoAgendamentoCalculation(metaConsulta.contatoCidadao),
  {
    field: metaConsulta.horario.inicial.absolutePath(),
    updates: {
      [metaConsulta.horario.final.absolutePath()]: limparHorarioFinal,
    },
  },
]

export const agendamentoConsultaDecorator = [createDecorator(...agendamentoConsultaCalculations)]

const metaConsultaCompartilhada = metaPath<AgendamentoConsultaCompartilhadaModel>()

const agendamentoConsultaCompartilhadaCalculations = [
  {
    field: metaConsultaCompartilhada.cidadaoParticipante.cidadao.absolutePath(),
    updates: {
      [metaConsultaCompartilhada.cidadaoParticipante.contato.email.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato?.email,
      [metaConsultaCompartilhada.cidadaoParticipante.contato.telefoneCelular.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato?.telefoneCelular,
      [metaConsultaCompartilhada.imprimirAgendamento.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => (cidadaoValue ? undefined : false),
    },
  },
  createContatoCidadaoAgendamentoCalculation(metaConsultaCompartilhada.cidadaoParticipante.contato),
  {
    field: metaConsultaCompartilhada.horario.inicial.absolutePath(),
    updates: {
      [metaConsultaCompartilhada.horario.final.absolutePath()]: limparHorarioFinal,
    },
  },
]

export const agendamentoConsultaCompartilhadaDecorator = [
  createDecorator(...agendamentoConsultaCompartilhadaCalculations),
]

const metaReserva = metaPath<AgendamentoReservaModel>()

export const agendamentoReservaCalculations = [
  {
    field: metaReserva.horario.inicial.absolutePath(),
    updates: {
      [metaReserva.horario.final.absolutePath()]: limparHorarioFinal,
    },
  },
]

export const agendamentoReservaDecorator = [createDecorator(...agendamentoReservaCalculations)]
